import React from 'react';

export type Content = JSX.Element | React.ComponentClass | string | number;

export type CellWidth = 'sm' | 'md' | 'lg' | number;

/** The column element needed to render children of table */
export interface ColumnProps {
  /** display properties for the header title */
  label?: Content;
  labelTooltip?: Content;
  dataKey: string;
  /** columns to display widget properties */
  sectionName?: string;
  starred?: boolean;
  /** used for keys that are depth 2 or derived */
  dataAccessor?: (rowData) => string | number;
  cellContent?: (rowData) => Content;
  sort?: boolean | ((rowDataA, rowDataB, sortAscending) => number);
  /** used to prepare strings for csv import */
  exportValue?: (rowData) => string | number;
  /** items that meet this check will always be sorted at the bottom of the list */
  isSortableCondition?: (rowData) => boolean;
  search?: boolean | ((rowDataA, rowDataB) => string);
  defaultSort?: boolean;
  /** cells have standard sizes (60px, 120px, 200px) */
  width?: CellWidth;
  maxWidth?: number;
  align?: 'left' | 'center' | 'right';
  defaultHidden?: boolean;
  alwaysVisible?: boolean;
  alwaysSearchable?: boolean;
  cellClassName?: string;
  sticky?: boolean;
  // stretch cell content will fill their parent td's width as the table grows
  stretch?: boolean;
}

export default class Column extends React.Component<ColumnProps> {}

export const getColumnWidth = (column: ColumnProps): number => {
  const width = column.width || 'md';
  const WIDTH_MAP = { sm: 60, md: 120, lg: 200 };
  return WIDTH_MAP[width] || width;
};

export const alignmentMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

export const alignment = ({ column }) => alignmentMap[column.align || 'center'];
